// import React from 'react';
// import ErrorMessage from './ErrorMessage';
// import styles from './DynamicFormRenderer.module.css';

// const RadioInput = ({ question, index, value, onChange, otherValue, onOtherChange, error, isSubmitted, data }) => {
//     if (!question.options || !Array.isArray(question.options)) {
//         return null;
//     }

//     return (
//         <div className={styles.questionWrapper}>
//             <div className={styles.questionHeader}>
//                 <span className={styles.questionNumber}>Q{index + 1}</span>
//                 <label className={styles.questionLabel}>
//                     {question.text}
//                     {question.required && <span className={styles.required}>*</span>}
//                 </label>
//             </div>
//             <div className={styles.optionsWrapper}>
//                 {question.options.map((option) => (
//                     <label
//                         key={option}
//                         className={`${styles.radioOption} ${value === option ? styles.radioOptionSelected : ''} ${isSubmitted ? styles.disabled : ''}`}
//                         htmlFor={`${question.id}-${option}`}
//                     >
//                         <input
//                             type="radio"
//                             name={question.id}
//                             value={option}
//                             id={`${question.id}-${option}`}
//                             checked={value === option}
//                             onChange={(e) => onChange(e.target.value)}
//                             disabled={isSubmitted}
//                             className={styles.radioInput}
//                         />
//                         <span className={styles.radioCircle}>
//                             {value === option && <span className={styles.radioCircleInner}></span>}
//                         </span>
//                         <span className={styles.optionText}>{option}</span>
//                     </label>
//                 ))}
//             </div>
//             {question.hasOtherOption && value === 'Other (Please specify)' && (
//                 <div className={styles.otherInputWrapper}>
//                     <input
//                         type="text"
//                         value={data[`${question.id}_other`] || ''}
//                         onChange={(e) => onOtherChange(e.target.value)}
//                         placeholder="Please specify"
//                         disabled={isSubmitted}
//                         className={`${styles.input} ${isSubmitted ? styles.disabled : ''}`}
//                     />
//                 </div>
//             )}
//             {error && <ErrorMessage message={error} />}
//         </div>
//     );
// };

// export default RadioInput;

import React from 'react';
import ErrorMessage from './ErrorMessage';
import styles from './DynamicFormRenderer.module.css';

const RadioInput = ({ question, index, value, onChange, otherValue, onOtherChange, error, isSubmitted, data, disabled = false, onBlur }) => {
    if (!question.options || !Array.isArray(question.options)) {
        return null;
    }

    const isDisabled = disabled;

    const handleChange = (newValue) => {
        onChange(newValue);
        // Note: Reason modal is now handled by handleImmediateFieldChange in DynamicForm
    };

    return (
        <div className={styles.questionWrapper}>
            <div className={styles.questionHeader}>
                <label className={styles.questionLabel}>
                    {question.text}
                    {question.required && <span className={styles.required}>*</span>}
                </label>
            </div>
            <div className={styles.optionsWrapper}>
                {question.options.map((option) => (
                    <label
                        key={option}
                        className={`${styles.radioOption} ${value === option ? styles.radioOptionSelected : ''} ${isDisabled ? styles.disabled : ''}`}
                        htmlFor={`${question.id}-${option}`}
                    >
                        <input
                            type="radio"
                            name={question.id}
                            value={option}
                            id={`${question.id}-${option}`}
                            checked={value === option}
                            onChange={(e) => handleChange(e.target.value)}
                            disabled={isDisabled}
                            className={styles.radioInput}
                        />
                        <span className={styles.radioCircle}>
                            {value === option && <span className={styles.radioCircleInner}></span>}
                        </span>
                        <span className={styles.optionText}>{option}</span>
                    </label>
                ))}
            </div>
            {question.hasOtherOption && value === 'Other (Please specify)' && (
                <div className={styles.otherInputWrapper}>
                    <input
                        type="text"
                        value={data[`${question.id}_other`] || ''}
                        onChange={(e) => onOtherChange(e.target.value)}
                        placeholder="Please specify"
                        disabled={isDisabled}
                        className={`${styles.input} ${isDisabled ? styles.disabled : ''}`}
                    />
                </div>
            )}
            {error && <ErrorMessage message={error} />}
        </div>
    );
};

export default RadioInput;